import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CustomerLoadReadService,
  CustomerLoadBoardModel,
  LoadBoardRequest,
  AnyValueModelString,
  CustomerLoadModel,
  PageModelCustomerLoadListModel,
  CustomerLoadListRequest,
  CustomerLoadListModel,
  PriceModel,
  CustomerPricePredictionRequest
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CustomerLoadReadApiService {
  constructor(private apiService: CustomerLoadReadService) {}

  public loadBoard(customerId: string, body: LoadBoardRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadBoardModel[]> {
    return this.apiService.customerLoadBoard(customerId, body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public generateNumber(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelString> {
    return this.apiService.customerLoadGenerateNumber(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getLoad(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadGet(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listLoads(customerId: string, body: CustomerLoadListRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelCustomerLoadListModel> {
    return this.apiService.customerLoadList(customerId, body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getListModel(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadListModel> {
    return this.apiService.customerLoadListModelGet(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public predictPrice(body: CustomerPricePredictionRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PriceModel> {
    return this.apiService.customerLoadPredictPrice(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
